export default class locales {
  constructor(translations = {}) {
    this.langs = {
      en: {
        name: 'English',
        translations: translations.en,
        reactIntlCode: 'en'
      },
      zh: {
        name: 'Chinese (Hong Kong)',
        translations: translations.zh,
        reactIntlCode: 'zh-Hant-HK'
      }
    };
  }

  isLangExists(lang) {
    const langsUsed = Object.keys(this.langs);
    return langsUsed.indexOf(lang) !== -1;
  }

  getTranslations(lang) {
    return this.langs[lang].translations;
  }

  getReactIntlCode(lang) {
    return this.langs[lang].reactIntlCode;
  }
}


// WEBPACK FOOTER //
// ./src/utils/Locales.js